import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import { useTranslation } from "react-i18next";

export default function SharedCollectionsList({ className = "" }) {
  const { t } = useTranslation();
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadShared() {
      const { data, error } = await supabase
        .from("v_collections_shared_with_me")
        .select("*");
      
      console.log("[SharedCollectionsList] Données reçues:", data);
      console.log("[SharedCollectionsList] Erreur:", error);
      
      if (error) console.error(error);
      else setCollections(data || []);
      setLoading(false);
    }
    loadShared();
  }, []);

  if (loading) return <p>{t("sharedCollectionsList.loading")}</p>;
  if (!collections.length) return null;

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${className}`}>
      {collections.map((c) => {
        // ✅ Détecter le bon ID selon la structure de la vue
        const collectionId = c.collection_id ?? c.id;
        // ✅ Détecter le bon nom selon la structure de la vue  
        const collectionTitle = c.title || c.nom || t("sharedCollectionsList.fallbackTitle");
        const collectionDescription = c.description || "—";
        
        console.log("[SharedCollectionsList] Affichage collection:", {
          collectionId,
          collectionTitle,
          raw: c
        });

        return (
          <div
            key={collectionId}
            className="border rounded p-4 hover:shadow transition-all"
          >
            <h3 className="text-lg font-semibold mb-2">{collectionTitle}</h3>
            <p className="text-sm text-gray-600">{collectionDescription}</p>
            <Link
              to={`/collections/${collectionId}`}
              className="inline-block mt-3 text-black underline hover:text-gray-600"
            >
              {t("sharedCollectionsList.view")}
            </Link>
          </div>
        );
      })}
    </div>
  );
}